import React, { createContext, useReducer, useEffect, useState } from "react";
import { BASE_URL_API_TRANXT, BASE_URL_API } from "../utils/Constants";
import AppReducer from "./AppReducer";
import swal from "sweetalert";
import { generateHashKey2, uniqueID2 } from "../utils/utilFuctions";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { getLatLong, getClientIP } from "../utils/utilFuctions";
import { API_ENDPOINTS } from "../utils/apiEndpoints";

// get user if present in session storage
const user = JSON.parse(sessionStorage.getItem("user"));
const wallet = JSON.parse(sessionStorage.getItem("wallet"));
const accountDetails = JSON.parse(sessionStorage.getItem("accountDetails"));
// encryption soon
const initialState = {
  Profileinfo: null,
  myAccountInfo: accountDetails,
  token: null,
  user: user,
  wallet: wallet,
  transactionLoader: false,
};
export const GlobalContext = createContext(initialState);

export const GlobalProvider = ({ children }) => {
  const location = useLocation();
  const [state, dispatch] = useReducer(AppReducer, initialState);
  const [services, setServices] = useState([]);

  // Actions for changing state

  function setTransactionLoaderState(loaderState) {
    dispatch({
      type: "SET_TRANSACTION_LOADER",
      payload: loaderState,
    });
  }

  function setToken(token) {
    dispatch({
      type: "SET_TOKEN",
      payload: token,
    });
  }
  function setProfileinfo(info) {
    console.log(info);
    dispatch({
      type: "SET_MY_ACCOUNT_INFO",
      payload: info,
    });
  }
  function setMyAccountInfo(info) {
    sessionStorage.setItem("accountDetails", JSON.stringify(info));
    dispatch({
      type: "SET_MY_ACCOUNT_INFO_DEVELOPER",
      payload: info,
    });
  }
  function logoutDeveloperLogin() {
    sessionStorage.removeItem("accountDetails");
    dispatch({
      type: "LOG_OUT_DEVELOPER",
      payload: null,
    });
  }
  function removeMyAccountInfo() {
    sessionStorage.removeItem("accountDetails");
    dispatch({
      type: "REMOVE_MY_ACCOUNT_INFO_DEVELOPER",
      payload: null,
    });
  }
  function setUserInfo(info) {
    sessionStorage.setItem("user", JSON.stringify(info));
    dispatch({
      type: "SET_USER_INFO",
      payload: info,
    });
  }
  function removeUserInfo() {
    sessionStorage.removeItem("user");
    dispatch({
      type: "REMOVE_USER_INFO",
      payload: null,
    });
  }

  function setWalletBalance(wallet) {
    sessionStorage.setItem("wallet", JSON.stringify(wallet));
    dispatch({
      type: "SET_WALLET",
      payload: wallet,
    });
    console.log(state);
  }

  const getWalletBalance = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        userID: user.ReferId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.GET_WALLET_BAL}`,
        requestOptions
      );
      const raw2 = await res.text();
      const data = JSON.parse(raw2);
      console.log(data);
      setWalletBalance(data);
      //  setWallet(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  // const logoutUser = () => {
  //   localStorage.clear();
  //   sessionStorage.clear();

  //   window.location.replace("/login");
  // };

  // const checkSession = async () => {
  //   try {
  //     const storedSessionId = localStorage.getItem("sessionId");

  //     if (!storedSessionId) {
  //       logoutUser();
  //       return;
  //     }
  //     const myHeaders = new Headers();
  //     myHeaders.append("Content-Type", "application/json");

  //     const raw = JSON.stringify({
  //       userid: user.ReferId,
  //       sessionid: storedSessionId,
  //       device: "WEB",
  //     });

  //     const requestOptions = {
  //       method: "POST",
  //       headers: myHeaders,
  //       body: raw,
  //       redirect: "follow",
  //     };

  //     const res = await fetch(
  //       `${BASE_URL_API}/api/Apitranxt/check_session`,
  //       requestOptions
  //     );
  //     const data = await res.json();

  //     if (data.responseCode === "00") {
  //     }
  //     else {
  //       forceLogout();
  //     }
  //   } catch (error) {
  //     console.log("error", error);
  //     forceLogout();
  //   }
  // };

  // const forceLogout = () => {
  //   localStorage.clear();
  //   sessionStorage.clear();

  //   window.location.href = "/login";
  // };

  // useEffect(() => {
  //   if (user?.ReferId) {
  //     checkSession();
  //   }
  // }, [location.pathname]);

  const handleAdminSessionOut = () => {
    sessionStorage.removeItem("admin_sessionid");
    localStorage.removeItem("admin_sessionid");
    localStorage.removeItem("admin_token");
    removeUserInfo();
    swal({
      title: "Session Expired",
      text: "Your account is logged in on another device or your session has expired.",
      icon: "warning",
      buttons: "OK",
      dangerMode: true,
      closeOnClickOutside: false,
    }).then(() => {
      window.location.replace("/admin");
    });
  };

  const handleRetailerSessionOut = () => {
    sessionStorage.removeItem("retailersessionid");
    localStorage.removeItem("retailersessionid");
    localStorage.removeItem("retailersessionid");
    removeUserInfo();
    swal({
      title: "Session Expired",
      text: "Your account is logged in on another device or your session has expired.",
      icon: "warning",
      buttons: "OK",
      dangerMode: true,
      closeOnClickOutside: false,
    }).then(() => {
      window.location.replace("/");
    });
  };

  const checkUserAdminSession = async () => {
    const currentSessionId = sessionStorage.getItem("admin_sessionid");
    const activeUser = state.user;
    if (!activeUser || !currentSessionId) return;

    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        userid: activeUser.pkid,
        sessionid: currentSessionId,
        device: "WEB_ADMIN",
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.check_session}`,
        requestOptions
      );

      const data = await res.json();
      console.log("Admin session Check", data);

      if (data.status !== "0") {
        handleAdminSessionOut();
      }
    } catch (error) {
      console.log("Session checking failed", error);
    }
  };

  useEffect(() => {
    const onStorageChange = (e) => {
      if (e.key === "admin_sessionid") {
        const mySession = sessionStorage.getItem("admin_sessionid");

        console.log("Storage changed", {
          newSession: e.newValue,
          mySession,
        });

        if (mySession && e.newValue && e.newValue !== mySession) {
          handleAdminSessionOut();
        }
      }
    };

    window.addEventListener("storage", onStorageChange);
    return () => window.removeEventListener("storage", onStorageChange);
  }, []);

  useEffect(() => {
    if (!state.user) return;

    const interval = setInterval(() => {
      checkUserAdminSession();
    }, 5000);

    return () => clearInterval(interval);
  }, [state.user]);

  function refreshWallet() {
    getWalletBalance();
  }

  const checkUserRetailerSession = async () => {
    const currentSessionId = sessionStorage.getItem("retailersessionid");
    const activeUser = state.user;

    if (!activeUser || !currentSessionId) return;

    try {
      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.check_sessionRetailer}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userid: activeUser.ReferId,
            sessionid: currentSessionId,
            device: "WEB",
          }),
        }
      );

      const data = await res.json();
      console.log("Retailer Session Check:", data);

      if (data.status !== "0") {
        handleRetailerSessionOut();
      }
    } catch (err) {
      console.log("Retailer session check failed:", err);
    }
  };

  useEffect(() => {
    const onStorageChange = (e) => {
      if (e.key === "retailersessionid") {
        handleRetailerSessionOut();
      }
    };

    window.addEventListener("storage", onStorageChange);
    return () => window.removeEventListener("storage", onStorageChange);
  }, []);

  useEffect(() => {
    if (!state.user) return;

    const interval = setInterval(() => {
      checkUserRetailerSession();
    }, 5000);

    return () => clearInterval(interval);
  }, [state.user]);

  useEffect(() => {
    const onStorageChange = (e) => {
      if (e.key === "retailersessionid") {
        handleRetailerSessionOut();
      }
    };

    window.addEventListener("storage", onStorageChange);
    return () => window.removeEventListener("storage", onStorageChange);
  }, []);

  const checkWalletBeforeBBPSBillPay = async (amount, callback, callback2) => {
    //WalletBalance
    //wallet
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        userID: state.user.ReferId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.GET_WALLET_BAL}`,
        requestOptions
      );

      // const res = await fetch(
      //   `${BASE_URL_API_TRANXT}/apiget.aspx?method=getbalance_new&userid=${state.user.ReferId}`,
      //   requestOptions
      // );
      const data = await res.json();
      setWalletBalance(data);
      if (data.WalletBalance < amount) {
        swal("Insufficient Balance", `Transaction Amount ${amount}`, "error");
        callback2();
      } else {
        callback();
      }
    } catch (error) {
      swal("Insufficient Balance", `Transaction Amount ${amount}`, "error");
      console.log("error", error);
    }
  };

  useEffect(() => {
    const fetchPath = async () => {
      setTransactionLoaderState(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append(
          "Authorization",
          "Basic " +
            btoa(
              "NoMoreOwnerName@bumppy.com:HJpdmF0ZSBzdGF0aWMgZmluYWwgU3RyaW5n"
            )
        );

        let coords = await getLatLong();
        const ip = await getClientIP();

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            userid: user.pkid,
            lattitude: coords[0],
            longitude: coords[1],
            ip: ip,
          }),
          redirect: "follow",
        };

        const response = await fetch(
          "https://api.bumppypay.com/api/Admin/admin/get_admin_access_info",
          requestOptions
        );
        const result = await response.json();

        if (result.status == "0") {
          setServices(result.services);
        }
      } catch (err) {
        console.error("Server error occurred while fetching menu:", err);
      } finally {
        setTransactionLoaderState(false);
      }
    };

    fetchPath();
  }, []);

  return (
    <GlobalContext.Provider
      value={{
        token: state.token,
        myAccountInfo: state.myAccountInfo,
        user: state.user,
        Profileinfo: state.Profileinfo,
        setToken,
        setUserInfo,
        removeUserInfo,
        setProfileinfo,
        setMyAccountInfo,
        setWalletBalance,
        wallet: state.wallet,
        transactionLoader: state.transactionLoader,
        refreshWallet,
        checkWalletBeforeBBPSBillPay,
        setTransactionLoaderState,
        removeMyAccountInfo,
        logoutDeveloperLogin,
        handleAdminSessionOut,
        checkUserAdminSession,
        handleRetailerSessionOut,
        checkUserRetailerSession,
        services: services,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
